import { NgModule } from '@angular/core';
import { ToggleCameraDirective } from './toggle-camera.directive'

@NgModule({
    declarations: [ToggleCameraDirective],
    exports: [ToggleCameraDirective]
})
export class CameraDirectiveModule {
}